var _rect, _path, _path2, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 40,
    viewBox: "0 0 142 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 40,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1068 -742C-1068 -743.105 -1067.1 -744 -1066 -744H6864C6865.1 -744 6866 -743.105 6866 -742V8520C6866 8521.1 6865.1 8522 6864 8522H-1066C-1067.1 8522 -1068 8521.1 -1068 8520V-742Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1066 -739H6864V-749H-1066V-739ZM6861 -742V8520H6871V-742H6861ZM6864 8517H-1066V8527H6864V8517ZM-1063 8520V-742H-1073V8520H-1063ZM-1066 8517C-1064.34 8517 -1063 8518.34 -1063 8520H-1073C-1073 8523.87 -1069.87 8527 -1066 8527V8517ZM6861 8520C6861 8518.34 6862.34 8517 6864 8517V8527C6867.87 8527 6871 8523.87 6871 8520H6861ZM6864 -739C6862.34 -739 6861 -740.343 6861 -742H6871C6871 -745.866 6867.87 -749 6864 -749V-739ZM-1066 -749C-1069.87 -749 -1073 -745.867 -1073 -742H-1063C-1063 -740.343 -1064.34 -739 -1066 -739V-749Z",
    fill: "#8ABFC0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-649 -192)",
    fill: "url(#paint0_diamond_0_1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -632,
    y: -176,
    width: 1408,
    height: 868,
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7178 30.5698V9.4303H50.1647V12.5578H38.589V18.1645H49.2684V21.3206H38.589V27.4518H50.1647V30.5698H34.7178Z",
    fill: "#010808"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0762 30.5698V9.4303H59.0809L70.2943 25.9929H69.3217V9.4303H73.193V30.5698H69.1215L58.013 13.9786H58.9474V30.5698H55.0762Z",
    fill: "#010808"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2864 14.8463H84.377V30.5698H88.2864V14.8463Z",
    fill: "#010808"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6577 9.4303H76.9688V12.5578H95.6577V9.4303Z",
    fill: "#010808"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.201 30.5698L106.299 21.292L110.265 20.863L116.673 30.5698H112.201ZM103.324 18.5936H106.489C107.338 18.5936 108.082 18.4982 108.74 18.3171C109.398 18.1359 109.922 17.8212 110.313 17.3731C110.704 16.9249 110.895 16.3147 110.895 15.5233C110.895 14.7318 110.704 14.1311 110.313 13.702C109.922 13.273 109.398 12.9774 108.73 12.8057C108.063 12.6341 107.319 12.5483 106.489 12.5483H103.324V18.5936ZM99.4619 30.5698V9.4303H106.899C108.749 9.4303 110.246 9.67821 111.4 10.174C112.554 10.6699 113.402 11.3755 113.955 12.2813C114.499 13.1872 114.775 14.2646 114.775 15.4947C114.775 17.3731 114.184 18.832 112.992 19.8808C111.8 20.9202 110.103 21.5209 107.901 21.683H103.333V30.5698H99.4619Z",
    fill: "#010808"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.194 27.6615C131.681 27.6615 132.959 27.3469 134.027 26.7175C135.095 26.0882 135.924 25.211 136.516 24.0668C137.107 22.9225 137.402 21.5781 137.402 20.0143C137.402 18.4601 137.107 17.0775 136.516 15.9333C135.924 14.7891 135.095 13.9023 134.027 13.2825C132.959 12.6532 131.681 12.3385 130.194 12.3385C128.706 12.3385 127.495 12.6436 126.418 13.2634C125.35 13.8832 124.52 14.7604 123.929 15.9047C123.338 17.0489 123.042 18.4219 123.042 20.0143C123.042 21.6067 123.328 22.9511 123.91 24.0954C124.492 25.2396 125.321 26.1168 126.399 26.7366C127.486 27.3469 128.744 27.6615 130.194 27.6615ZM130.194 30.9988C128.01 30.9988 126.103 30.5411 124.454 29.6353C122.804 28.7295 121.526 27.4422 120.601 25.7831C119.676 24.124 119.219 22.2074 119.219 20.0239C119.219 17.8403 119.676 15.8856 120.601 14.2265C121.526 12.5674 122.804 11.2801 124.454 10.3743C126.103 9.46843 128.01 9.01074 130.194 9.01074C132.377 9.01074 134.361 9.46843 136.02 10.3743C137.679 11.2801 138.966 12.5674 139.891 14.2074C140.816 15.857 141.274 17.7926 141.274 20.0143C141.274 22.236 140.806 24.143 139.872 25.7926C138.937 27.4422 137.641 28.7199 135.982 29.6258C134.322 30.5411 132.396 30.9988 130.194 30.9988Z",
    fill: "#010808"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5742 0V3.52801H4.27267V36.472H25.5742V40H0.725586V0H25.5742Z",
    fill: "#010808"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4557 13.4636H13.3115V26.5363H22.4557V13.4636Z",
    fill: "#010808"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5735 5.88324V9.41125H10.1838V30.5888H25.5735V34.1169H6.63672V5.88324H25.5735Z",
    fill: "#010808"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.279 841.189) rotate(-28.0293) scale(1375.85 1875.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#994732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ABFC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1N);
export default __webpack_public_path__ + "static/media/Group 1N.be551def23bdb6287412b0ec8afc355c.svg";
export { ForwardRef as ReactComponent };